import iframeResize from '@iframe-resizer/parent'

import { getElements } from '../Utility/Dom'

class Iframe {
  private items: NodeListOf<HTMLElement>

  constructor() {
    this.items = getElements('iframe')
  }

  public init(): void {
    this.resize()
    this.addEvents()
  }

  private addEvents(): void {
    window.addEventListener('load', (): void => {
      // Scroll to the anchor element when requested after the iframe has resized
      // to ensure correct anchor positioning
      if (window.location.hash) {
        setTimeout((): void => {
          const element = document.querySelector(window.location.hash)
          element?.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 300)
      }
    })
  }

  private resize(): void {
    this.items.forEach((item: HTMLIFrameElement): void => {
      iframeResize({ license: '1jy4dww5qzv-s54r73oxcn-v59f4kfgfz' }, item)
    })
  }
}

const iframe = new Iframe()
iframe.init()
